/* eslint-disable */
require('echarts/extension/bmap/bmap');
import ECharts from 'echarts';
import Api from 'Api/index';
import Utils from 'Utils/index';
import VBread from 'Components/v-bread';
import VDrawer from 'Components/v-drawer';
import VDynamicForm from 'Components/v-dynamic-form';
import VDynamicFromItem from 'Components/v-dynamic-form-item';
import 'Utils/filter';
import Rules from './rules/index';
import store from '../store';

// import { Message } from 'element-ui';

export default {
  install(Vue) {
    // 1. 添加全局方法或属性
    Object.defineProperty(Vue, 'myGlobalMethod', { value: () => {} });

    // 2. 添加全局资源
    Vue.directive('my-directive', {
      /* bind(el, binding, vnode, oldVnode) {
        window.console.log(oldVnode);
        // 逻辑...
      }, */
    });

    // 3. 注入组件
    Vue.mixin({
      created() {
        // 逻辑...
      },
    });

    // 自定义实例属性 $ECharts ECharts对象
    Object.defineProperty(Vue.prototype, '$ECharts', { value: ECharts });

    // 自定义实例属性 $Api Api对象
    Object.defineProperty(Vue.prototype, '$Api', { value: Api });

    // 自定义实例属性 $Rules 表单验证规则
    Object.defineProperty(Vue.prototype, '$Rules', { value: Rules });

    // 自定义实例属性 $Utils 工具方法
    Object.defineProperty(Vue.prototype, '$Utils', { value: Utils });

    // 权限判断
    Object.defineProperty(Vue.prototype, 'auth', {
      value: (url) => {
        const menuUrl = url;
        const authUrlList = store.state.authUrlList;
        const userType = store.getters.userType;
        // 没有配置相关权限或者非超级管理员身份
        if (!authUrlList[menuUrl] && userType !== 1) {
          return false;
        }
        return true;
      },
    });

    // 全局组件
    Vue.component('VBread', VBread);
    Vue.component('VDrawer', VDrawer);
    Vue.component('VDynamicForm', VDynamicForm);
    Vue.component('VDynamicFormItem', VDynamicFromItem);
  },
};



// WEBPACK FOOTER //
// ./src/utils/plugin.js